<!--
 * @Description: 课程管理
 * @Author: shangao
 * @Date: 2022-04-14 09:10:46
 * @LastEditTime: 2022-05-06 15:15:27
 * @LastEditors: shangao
 * @FilePath: \teaching-web\src\views\manage\course.vue
-->
<template>
  <div class="manage-course">
    <el-form inline size="small" class="form-search" :model="searchForm">
      <el-form-item>
        <el-input v-model="searchForm.name" placeholder="请输入名称" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
        <el-button @click="exportLiveList">导出列表</el-button>
      </el-form-item>
    </el-form>
    <div class="table-operation">
       
      <el-button size="small" type="primary" @click="handleCreate">新建课程</el-button>
    </div>
    <m-table ref="table" url="live/listLiveCourse" :columns="columns" :form-data="formData">
      <template slot="thumbnail" slot-scope="{ row }">
        <el-image style="width: 80px; height: 45px" fit="cover" :src="row.thumbnail">
          <img slot="error" :src="poster" />
          <!-- <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div> -->
        </el-image>
      </template>
      <template slot="status" slot-scope="{ row }">
        <i :class="`status status-${row.status}`"></i>{{ row.statusText }}</template>
      <template slot="action" slot-scope="{ row }">
        <!-- <template v-if="row.status == 2">--</template> -->
        <template>
          <el-button @click="confirmDelete(row)" type="text" size="small">删除</el-button>
            
          <el-button @click="handleUpdate(row)" type="text" size="small">编辑</el-button>
        </template>
      </template>
    </m-table>
  </div>
</template>

<script>
import MTable from "@/components/Table";
import { axiosFactory } from "@/services/axios-factory";
import { download } from '@/utils/util';
const poster = require('@/assets/img/poster.png')
console.log(poster)
const columns = [
  { label: "名称", prop: "name" },
  { label: "直播开始时间", prop: "startTime" },
  { label: "直播结束时间", prop: "endTime" },
  // { label: '视频文件', prop: 'fielName' },
  { label: "视频封面", scopedSlots: "thumbnail" },
  { label: "简介", prop: "description" },
  { label: "主办单位", prop: "organizer" },
  { label: "学段", prop: "phaseName" },
  { label: "学科", prop: "subjectName" },
  { label: '总播放量', prop: 'allviewCount' },
  { label: '直播', prop: 'viewCount' },
  { label: '回放', prop: 'resViewCount' },
  { label: "操作", scopedSlots: "action" },
];
export default {
  components: {
    MTable,
  },
  data() {
    return {
      columns: Object.freeze(columns),
      poster,
      searchForm: {
        name: "",
      },
      formData: {},
    };
  },
  methods: {
    // 搜索
    onSearch() {
      this.formData = { ...this.searchForm };
    },
    // 提示框-删除
    confirmDelete(record) {
      this.$confirm("确定要删除此课程？", "删除", {
        type: "warning",
      }).then(() => {
        this.axiosDelete({ id: record.id });
      });
    },
    async axiosDelete(params) {
      const url = "live/delLive";
      await axiosFactory({ url, params });
      this.$message({ message: "删除成功！", type: "success" });
      this.$refs.table.reload("delete");
    },
    // 新增课程
    handleCreate() {
      //this.$message({ message: "系统正在升级中，暂时不对外开放"});
     this.$router.push({ path: "/manage/course/create" });
    },
    // 批量通过
    handleUpdate(record) {
      console.log({ ...record });
      this.$router.push({
        path: "/manage/course/create",
        query: { id: record.id },
      });
      // if (this.selectedRows.length === 0) {
      //   this.$message({ message: '请先勾选评论进行操作！', type: 'warning' })
      // } else {
      //   this.$confirm('是否通过选中的评论？', '提示', {
      //     type: 'warning'
      //   }).then(() => {
      //     const ids = this.selectedRows.map(item => item.id)
      //     const params = { id: ids.join(','), status: '1' }
      //     this.axiosAudit(params)
      //   })
      // }
    },
    // 导出列表
    exportLiveList() {
      this.$api.live.getExportLive(this.searchForm).then(res => {
        const type = res.headers['content-type'];
        const fileName = `课程管理列表.xlsx`;
        download(res.data, type, fileName);
      })
    }
  },
};
</script>

<style lang="less">
.manage-course {
  position: relative;
  .form-search {
    position: relative;
    z-index: 10;
  }
  .table-operation {
    position: absolute;
    z-index: 100;
    top: 16px;
    right: 24px;
  }
}
</style>
